import {
  useCurrentTrustAccount,
  useTrustAccountPermissions
} from '@/features/trust-accounts/providers';

import {useTrustAccountBadgeCounts} from './useTrustAccountBadgeCounts';

/** A payment request targets a buyer, so it needs at least one on the account. */
export function useCanCreatePaymentRequest(): boolean {
  const {id: trustAccountId} = useCurrentTrustAccount();
  const {canCollectPayments} = useTrustAccountPermissions();
  const {buyersCount} = useTrustAccountBadgeCounts({trustAccountId});
  return canCollectPayments && buyersCount > 0;
}
